import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { House, CaretRight } from 'phosphor-react';
import './Breadcrumbs.css';

const Breadcrumbs = ({ customItems = null }) => {
  const location = useLocation();
  
  if (customItems) {
    return (
      <nav className="breadcrumbs" aria-label="Navegação breadcrumb">
        <ol className="breadcrumb-list" itemScope itemType="https://schema.org/BreadcrumbList">
          {customItems.map((item, index) => (
            <li 
              key={index} 
              className={`breadcrumb-item ${index === customItems.length - 1 ? 'current' : ''}`}
              itemProp="itemListElement" 
              itemScope 
              itemType="https://schema.org/ListItem"
            >
              {index > 0 && <CaretRight size={12} className="breadcrumb-separator" />}
              {item.href ? (
                <Link to={item.href} itemProp="item">
                  <span itemProp="name">{item.name}</span>
                </Link>
              ) : (
                <span itemProp="name" aria-current="page">{item.name}</span>
              )}
              <meta itemProp="position" content={index + 1} />
            </li>
          ))}
        </ol>
      </nav>
    );
  }

  const pathnames = location.pathname.split('/').filter(Boolean);
  
  if (pathnames.length === 0) return null;

  const breadcrumbItems = [
    { name: 'Início', href: '/' }
  ];

  const pathMap = {
    'shop': 'Loja',
    'produtos': 'Produtos',
    'about': 'Sobre Nós',
    'contact': 'Contactos',
    'simple-quote': 'Orçamento Simples',
    'advanced-quote': 'Orçamento Avançado',
    'interest-list': 'Lista de Interesse',
    'orders': 'Pedidos',
    'terms': 'Termos e Condições',
    'product': 'Produto'
  };

  let currentPath = '';
  pathnames.forEach((pathname, index) => {
    currentPath += `/${pathname}`;
    
    if (pathMap[pathname]) {
      breadcrumbItems.push({
        name: pathMap[pathname],
        href: index === pathnames.length - 1 ? null : currentPath
      });
    } else if (pathname === pathnames[pathnames.length - 1] && !isNaN(pathname)) {
      // Para IDs de produtos
      breadcrumbItems.push({
        name: `Produto #${pathname}`,
        href: null
      });
    }
  });

  if (breadcrumbItems.length <= 1) return null;

  return (
    <nav className="breadcrumbs" aria-label="Navegação breadcrumb">
      <ol className="breadcrumb-list" itemScope itemType="https://schema.org/BreadcrumbList">
        {breadcrumbItems.map((item, index) => (
          <li 
            key={index} 
            className={`breadcrumb-item ${!item.href ? 'current' : ''}`}
            itemProp="itemListElement" 
            itemScope 
            itemType="https://schema.org/ListItem"
          >
            {index > 0 && <CaretRight size={12} className="breadcrumb-separator" />}
            {index === 0 && <House size={14} className="home-icon" />}
            {item.href ? (
              <Link to={item.href} itemProp="item">
                <span itemProp="name">{item.name}</span>
              </Link>
            ) : (
              <span itemProp="name" aria-current="page">{item.name}</span>
            )}
            <meta itemProp="position" content={index + 1} />
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
